import { AxiosInstance } from 'axios';

import { FormName } from '@topconagriculture/feed-types';

import { APIManagerConfig } from '../apiManager';
import { BunkScoreGrade, FarmParams } from '../../../store/entities/settings/settings.types';

const SettingsServiceFactory = ({ HTTPBase, config }: { HTTPBase: AxiosInstance; config: APIManagerConfig }) => {
  return {
    getSettings: (): Promise<FarmParams> => HTTPBase.get(`farm/${config.farmId}/params`).then((res) => res.data),
    getWeighBridgeSystem: () => HTTPBase.get(`farm/${config.farmId}/weighbridge/systems`).then((res) => res.data),
    updateSettings: (params: any, formName: FormName): Promise<any> =>
      HTTPBase.patch(`farm/${config.farmId}/params`, params, { headers: { formName } }).then((res) => res.data),
    getThirdParties: () => HTTPBase.get(`farm/${config.farmId}/thirdparties`).then((res) => res.data),
    updateThirdParties: (id: string, payload) =>
      HTTPBase.patch(`farm/${config.farmId}/thirdparties/${id}`, payload).then((res) => res.data),
    updatePermissions: (sharedFarmId: string) =>
      HTTPBase.post(`/user/permissions/${sharedFarmId}`).then((res) => res.data),
    getBunkScoreGrades: () => HTTPBase.get(`farm/${config.farmId}/bunkscoregrades`).then((res) => res.data),
    updateBunkScoreGrades: (payload: Partial<BunkScoreGrade>[], formName) =>
      HTTPBase.patch(`farm/${config.farmId}/bunkscoregrades`, payload, { headers: { formName } }).then(
        (res) => res.data,
      ),
  };
};

export default SettingsServiceFactory;
